import { render } from "./dragVerify.vue?vue&type=template&id=5d180616&scoped=true"
import script from "./dragVerify.vue?vue&type=script&scope=true&lang=js"
export * from "./dragVerify.vue?vue&type=script&scope=true&lang=js"

import "./dragVerify.vue?vue&type=style&index=0&id=5d180616&scoped=true&lang=scss"

import exportComponent from "D:\\phpstudy_pro\\gpt\\chatgpt-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d180616"]])

export default __exports__